<template>
  <div
    class="upload-image"
    @dragleave.prevent
    @dragover.prevent
    @drop.prevent="onDrop($event)"
  >
    <div class="imagearea">
      <div class="image">
        <img
          src="@/assets/images/icons/default-image.svg"
          class="icon"
          alt=""
        />
      </div>
      <div v-show="docType == 'identify'" class="text">
        「ファイルを選択する」を押して、ご本人さま確認書類のファイル（jpg /
        png）を選択してください。
      </div>
      <div v-show="docType == 'income'" class="text">
        「ファイルを選択する」を押して、収入証明書のファイル（jpg/png/pdf）を選択してください。
      </div>
    </div>
    <div
      class="btnarea"
      @dragleave.prevent
      @dragover.prevent
      @drop.prevent="onDrop($event)"
    >
      <label class="btn-upload" :for="id">
        <span class="pc">ファイルを選択する</span>
        <span class="sp">アップロードする</span>
        <input :id="id" type="file" @change.prevent="onDrop($event)" />
      </label>
    </div>
    <canvas
      :id="`canvas${id}`"
      width="0"
      height="0"
      style="display: none"
    ></canvas>
  </div>
</template>

<script>
export default {
  name: "UploadImage",
  props: {
    docType: { type: String, default: "" },
    id: { type: String, default: "" },
  },
  emits: ["onDrop", "error"],
  methods: {
    onDrop: function (event) {
      // const processingCapacity = 1000000
      const maxWidthPng = this.docType === 'income' ? 1366 : 400;
      const maxWidthJpg = 1000;
      const self = this;
      let canvasId = `canvas${this.id}`;
      let fileList = event.target.files
        ? event.target.files
        : event.dataTransfer.files;
      if (fileList.length > 1) {
        // let errors = { fileNo: ["manyfile"] };
        // this.$emit("error", errors);
        return;
      }
      let imgFile = fileList[0];

      const allowedFileReg =
        this.docType === "income"
          ? /^(image\/jpeg|image\/png|application\/pdf)$/
          : /^(image\/jpeg|image\/png)$/;
      if (!imgFile.type.match(allowedFileReg)) {
        // let errors = { fileNo: ["file_extension"] };
        // this.$emit("error", errors);
        return;
      }

      let maxWidth = maxWidthJpg;
      if (imgFile.type.match(/image\/png/gi)) {
        maxWidth = maxWidthPng;
      }
      let image = new Image();
      let reader = new FileReader();

      // function base64ToBlob (base64, fileType) {
      //   var barr, bin, i, len
      //   bin = atob(base64.split('base64,')[1])
      //   len = bin.length
      //   barr = new Uint8Array(len)
      //   i = 0
      //   while (i < len) {
      //     barr[i] = bin.charCodeAt(i)
      //     i++
      //   }
      //   return new Blob([barr], {type: fileType})
      // }
      if (imgFile.type.match(/application\/pdf/gi)) {
        reader.onload = function (e) {
          let base64 = e.target.result;
          let fileData = base64.substr(base64.indexOf(",") + 1);
          self.$emit("onDrop", fileData, imgFile.name);
        };
      } else {
        reader.onload = function (e) {
          image.onload = function () {
            let width, height, ratio;
            if (image.width > image.height) {
              // 横長の画像は横のサイズを指定値にあわせる
              ratio = image.height / image.width;
              width = maxWidth;
              height = maxWidth * ratio;
            } else {
              // 縦長の画像は縦のサイズを指定値にあわせる
              ratio = image.width / image.height;
              width = maxWidth * ratio;
              height = maxWidth;
            }
            // console.log('width', width)
            // console.log('height', height)
            let canvas = document.getElementById(canvasId);
            canvas.setAttribute("width", width);
            canvas.setAttribute("height", height);

            let ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, width, height);
            // canvasにサムネイルを描画
            ctx.drawImage(image, 0, 0, width, height);
            // canvasからbase64画像データを取得
            let base64 = canvas.toDataURL(imgFile.type);
            // let orgBlog = base64ToBlob(base64, imgFile.type)
            // let orgBlogSize = orgBlog.size
            // if (orgBlogSize >= processingCapacity) {
            //   let capacityRatio = processingCapacity / orgBlogSize
            //   base64 = canvas.toDataURL(imgFile.type, capacityRatio)
            //   let resizeBlob = base64ToBlob(base64, imgFile.type)
            //   let resizeBlobSize = resizeBlob.size
            // }
            let fileData = base64.substr(base64.indexOf(",") + 1);
            // console.log("img", fileData);
            self.$emit("onDrop", fileData, imgFile.name);
          };
          image.src = e.target.result;
        };
      }
      reader.readAsDataURL(imgFile);

      // this.parseImagFIle(imgFile)
    },
    parseImagFIle: function (imgFile) {
      let reader = new FileReader();
      reader.onload = (e) => {
        let result = e.target.result;
        let fileData = result.substr(result.indexOf(",") + 1);
        // console.log('result', result)
        // console.log('fileData', fileData)
        this.$emit("onDrop", fileData, imgFile.name);
      };
      reader.readAsDataURL(imgFile);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/stylesheets/styles";
.upload-image {
  background-color: $light;
  border: 2px dashed $secondary;
  padding: 20px;
  @include mq-up(md) {
    padding: 40px;
  }
  > .imagearea {
    @include flex(flex, flex-start, center, row, nowrap);
    > .image {
      @include flex(flex, center, center, row, nowrap);
      width: 100%;
      > .icon {
        width: 100%;
        max-width: 100px;
      }
      @include mq-up(md) {
        width: 25%;
      }
    }
    > .text {
      display: none;
      @include mq-up(md) {
        padding-left: 10px;
        display: block;
        width: 75%;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
  > .btnarea {
    margin: 25px auto 0px;
    max-width: 260px;
  }
}
.btn-upload {
  background-color: $dark;
  border: 1px solid $dark;
  color: $white;
  width: 100%;
  text-align: center;
  cursor: pointer;
  padding: 12px 20px;
  display: inline-block;
  border-radius: 25px;
  font-size: 14px;
  > .pc {
    display: none;
  }
  > .sp {
    display: inline;
    line-height: 20px;
    > .icon {
      width: 18px;
      margin-right: 3px;
    }
  }
  @include mq-up(md) {
    font-size: 16px;
    .pc {
      display: inline;
    }
    .sp {
      display: none;
    }
  }
  &:hover {
    background-color: $gray;
  }
  input {
    display: none;
  }
}
</style>
